import React from "react";
import { Space, DatePicker, Select, Input, Col, Row } from "antd";

const PointHistoryFilters = ({ filters, onFiltersChange }) => {
  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Space direction="vertical" size={4} style={{ width: "100%" }}>
          <span>User Email</span>
          <Input.Search
            style={{ width: "100%" }}
            placeholder="Search by user email"
            allowClear
            onSearch={(value) =>
              onFiltersChange({ ...filters, userEmail: (value || "").trim() || undefined })
            }
          />
        </Space>
      </Col>

      <Col xs={24} sm={12} md={8} lg={6}>
        <Space direction="vertical" size={4} style={{ width: "100%" }}>
          <span>Type</span>
          <Select
            placeholder="ALL"
            allowClear
            style={{ width: "100%" }}
            onChange={(value) =>
              onFiltersChange({ ...filters, type: value })
            }
          >
            <Select.Option value="EARN">EARN</Select.Option>
            <Select.Option value="REDEEM">REDEEM</Select.Option>
            <Select.Option value="EXPIRED">EXPIRED</Select.Option>
            <Select.Option value="REFUND">REFUND</Select.Option>
          </Select>
        </Space>
      </Col>

      <Col xs={24} sm={24} md={12} lg={6}>
        <Space direction="vertical" size={4} style={{ width: "100%" }}>
          <span>Date Range</span>
          <DatePicker.RangePicker
            style={{ width: "100%" }}
            value={
              filters.startDate && filters.endDate
                ? [filters.startDate, filters.endDate]
                : null
            }
            onChange={(dates) =>
              dates
                ? onFiltersChange({
                    ...filters,
                    startDate: dates[0],
                    endDate: dates[1],
                  })
                : onFiltersChange({
                    ...filters,
                    startDate: undefined,
                    endDate: undefined,
                  })
            }
          />
        </Space>
      </Col>
    </Row>
  );
};

export default PointHistoryFilters;
